export const propertyType = ["Residential", "Commercial"];
export default propertyType;
